import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './textarea.css';
var cx = classnames.bind(styles);
export default function TextArea(_ref) {
  var autoHeight = _ref.autoHeight,
      bordered = _ref.bordered,
      className = _ref.className,
      countCharacters = _ref.countCharacters,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, ["autoHeight", "bordered", "className", "countCharacters", "maxLength", "onChange"]);

  var textAreaRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      textAreaHint = _useState2[0],
      setTextAreaHint = _useState2[1];

  var updateHeight = useCallback(function () {
    if (autoHeight && textAreaRef.current) {
      var _window$getComputedSt = window.getComputedStyle(textAreaRef.current),
          minHeight = _window$getComputedSt.minHeight,
          borderBottomWidth = _window$getComputedSt.borderBottomWidth,
          borderTopWidth = _window$getComputedSt.borderTopWidth;

      var minHeightNum = parseFloat(minHeight);
      var borders = parseFloat(borderTopWidth) + parseFloat(borderBottomWidth);
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = "".concat(Math.max(minHeightNum, textAreaRef.current.scrollHeight + borders), "px");
      textAreaRef.current.style.resize = 'none';
    } else if (textAreaRef.current) {
      textAreaRef.current.style.height = null;
      textAreaRef.current.style.resize = null;
    }
  }, [autoHeight]);
  var updateHint = useCallback(function () {
    if (countCharacters && textAreaRef.current) {
      var postfix = maxLength && maxLength > 0 ? "/".concat(maxLength) : '';
      var valueLength = textAreaRef.current.value.length;
      setTextAreaHint("".concat(valueLength > 0 ? valueLength : 0).concat(postfix));
    }
  }, [countCharacters, maxLength]);
  var handleChange = useCallback(function (e) {
    onChange(e);
    updateHeight();
    updateHint();
  }, [onChange, updateHeight, updateHint]);
  useEffect(function () {
    updateHeight();
    updateHint();
  }, [updateHeight, updateHint]);
  var classes = cx('textarea', {
    bordered: bordered
  }, className);
  return React.createElement(Fragment, null, React.createElement("textarea", _extends({
    className: classes,
    onChange: handleChange,
    ref: textAreaRef
  }, rest)), !!textAreaHint && React.createElement("div", {
    className: styles.textAreaHint
  }, textAreaHint));
}
TextArea.propTypes = {
  /** Boolean to automatically adjust height */
  autoHeight: PropTypes.bool,

  /** Boolean to set box-shadow on element */
  bordered: PropTypes.bool,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Should include the current count of the characters in the textarea */
  countCharacters: PropTypes.bool,

  /** The maximum number of characters that can be typed in the textarea */
  maxLength: PropTypes.number,

  /** Change handler */
  onChange: PropTypes.func,

  /** Text value */
  value: PropTypes.string
};
TextArea.defaultProps = {
  autoHeight: false,
  bordered: true,
  className: undefined,
  countCharacters: false,
  maxLength: undefined,
  onChange: function onChange() {},
  value: undefined
};